import { render, staticRenderFns } from "./ActorMessage.vue?vue&type=template&id=baa210b0"
import script from "./ActorMessage.vue?vue&type=script&lang=js"
export * from "./ActorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports